import React, { Fragment } from 'react';
import { Table, Container } from 'react-bootstrap';
import UploadFormRow from './UploadFormRow';
import withTranslations from '../../../../utils/HighOrderComponent';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { allowedFileFormatsText } from '../../../../constants/globals';
import Tooltip from '@mui/material/Tooltip';
import ErrorLabel from '../../ErrorLabel';
import { isUndefined } from 'lodash';
import '../../../../styles/css/UploadFormTable.css';
import { Button } from '@mui/material';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';

const UploadFormTable = (props) => {
  const {
      t,
      placeholder,
      enableMultiple = true,
      name,
      onChange,
      errors,
      allowedFormats,
      errorsHandler,
      deleteColWidth = '15%',
      handleDeleteDocument,
      uploadedFiles,
      renderButton = false,
      showButtonAllowedTypes = false,
    } = props || {},
    { Placeholders, Tooltips } = t || {};

  let filePreviewTable;
  let fileNames = [];

  for (let i = 0; i < uploadedFiles.length; i++) {
    fileNames.push(uploadedFiles[i]?.name);
  }

  const files = fileNames.map((uploadedFile, index) => (
    <UploadFormRow
      key={index}
      uploadedFile={uploadedFile}
      handleDelete={handleDeleteDocument}
    />
  ));

  const errorRemovalHandler = () => {
    errorsHandler((prevError) => {
      delete prevError[name];
      return prevError;
    });
  };

  if (uploadedFiles?.length > 0) {
    filePreviewTable = (
      <Table
        responsive
        hover
        id="upload-table"
        className="wrapper-fade-in table-sm"
      >
        <thead>
          <tr>
            <th width="85%" className="text-left">
              {t.name}
            </th>
            <th width={deleteColWidth} className="text-center">
              {t.delete}
            </th>
          </tr>
        </thead>
        <tbody>{files}</tbody>
      </Table>
    );
  }

  const message = enableMultiple ? t.messageMultiple : t.messageSingle;

  const errorMessage = errors?.[name] || undefined;
  const hasError = !isUndefined(errorMessage);

  const renderUploadTrigger = !enableMultiple
    ? fileNames?.length === 0
    : enableMultiple;

  const placeholderText =
    placeholder ||
    (!enableMultiple ? Placeholders.singleFile : Placeholders.multipleFiles);

  let labelStyle = 'w-100 wrapper-fade-in mb-1';
  if (!renderButton) labelStyle += ' custom-file-upload';

  return (
    <Fragment>
      <Container fluid className="pr-2 pl-2 wrapper-fade-in">
        <br />
        {filePreviewTable && filePreviewTable}
        {!!renderUploadTrigger && (
          <label className={labelStyle}>
            <input
              name={name}
              accept={allowedFormats || allowedFileFormatsText}
              multiple={!!enableMultiple}
              type="file"
              onChange={(event) => {
                onChange(event);
                hasError && errorRemovalHandler?.();
              }}
            />
            {renderButton ? (
              <UploadButton
                placeholderText={placeholderText}
                showButtonAllowedTypes={showButtonAllowedTypes}
                allowedFormats={allowedFormats}
                Tooltips={Tooltips}
              />
            ) : (
              <Fragment>
                <Tooltip title={placeholderText} placement="top" arrow={true}>
                  <CloudUploadIcon
                    className="icon-button-style"
                    fontSize={'large'}
                  />
                </Tooltip>
                <i className="m-auto">{placeholderText}</i>
              </Fragment>
            )}
          </label>
        )}
        {!renderButton && <hr className="lineBreaker w-100 mt-1 mb-1" />}
        {!enableMultiple && !!renderUploadTrigger && (
          <small className="col-md-11">
            <em>
              <span>* </span>
              {message}
            </em>
          </small>
        )}
      </Container>
      <div className="position-relative col-md-11 ml-auto mt-2">
        <ErrorLabel error={errorMessage} />
      </div>
    </Fragment>
  );
};

const UploadButton = (props) => {
  const { showButtonAllowedTypes, allowedFormats, Tooltips } = props || {};
  return showButtonAllowedTypes ? (
    <Tooltip
      title={`${Tooltips?.allowedFormats} ${allowedFormats}`}
      placement="bottom"
      arrow={true}
    >
      <div>
        <ButtonComponent {...props} />
      </div>
    </Tooltip>
  ) : (
    <ButtonComponent {...props} />
  );
};

const ButtonComponent = (props) => (
  <Button
    variant="contained"
    component="span"
    className="default-btn-primary"
    size="small"
    startIcon={<FileUploadRoundedIcon />}
  >
    {props?.placeholderText}
  </Button>
);

export default withTranslations(UploadFormTable, 'UploadFormTable');
